// extracted by mini-css-extract-plugin
export default {"modal":"MatcherModals_modal__Zw+yO","footer":"MatcherModals_footer__J3BVE"};